<template>
    <div>
        <div class="ppv2-flex ppv2-border-b ppv2-border-[#E2E6EC] ppv2-mb-5" :style="{ gap: normalizeSize(28, true) }">
            <button
                v-for="tab in tabs"
                :key="tab.key"
                type="button"
                class="ppv2-pb-3 ppv2--mb-px ppv2-border-b-2 ppv2-transition-colors"
                :class="
                    activeTab === tab.key
                        ? 'ppv2-border-[#7D2DBD] ppv2-text-[#7D2DBD] poppinsSemiBold'
                        : 'ppv2-border-transparent ppv2-text-[#6B7480] poppinsMedium'
                "
                :style="{ fontSize: normalizeFontSize(15) }"
                @click="setTab(tab.key)"
            >
                {{ tab.label }}
            </button>
        </div>

        <applications-table v-if="activeTab === 'api'" :user-id="userId" :token="token" :initial-id="initialId" />
        <WebhooksTable v-else :token="token" />
    </div>
</template>

<script>
import ApplicationsTable from './ApplicationsTable.vue'
import WebhooksTable from './WebhooksTable.vue'
import normalizeSize from '../../../utils/normalizeSize'
import normalizeFontSize from '../../../utils/normalizeFontSize'

export default {
    name: 'ApiWebhooksPage',
    components: { ApplicationsTable, WebhooksTable },
    props: {
        userId: { type: [Number, String, null], default: null },
        token: { type: String, default: '' },
        initialId: { type: String, default: '' },
    },
    data() {
        const tab = new URLSearchParams(window.location.search).get('tab')
        return { activeTab: tab === 'webhooks' && !this.initialId ? 'webhooks' : 'api' }
    },
    computed: {
        tabs() {
            return [
                { key: 'api', label: this.$t('webhooks.tab_api') },
                { key: 'webhooks', label: this.$t('webhooks.tab_webhooks') },
            ]
        },
    },
    methods: {
        normalizeSize,
        normalizeFontSize,
        setTab(tab) {
            this.activeTab = tab
            const url = new URL(window.location.href)
            url.searchParams.set('tab', tab)
            window.history.replaceState(window.history.state, '', url)
        },
    },
}
</script>
